import { useNavigate } from 'react-router-dom';
import { IoSettingsOutline, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { LuBrain, LuCalendar } from 'react-icons/lu';
import { TbLogout2, TbUsersGroup } from 'react-icons/tb';
import { PiTag } from 'react-icons/pi';
import MenuItem from './MenuItem';
import styles from './Menu.module.css';
import { authService } from '../../services/auth.service';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PermissionChecker from '../UI/PermissionChecker/PermissionChecker';
import { PERMISSIONS } from '../../shared/permission';
import { clearAuth } from '../../redux/slices/auth';

function Menu({ isCollapsed, onToggleCollapse }) {
    const { t } = useTranslation('menu');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = async () => {
        try {
            await authService.logout();
            dispatch(clearAuth());
            navigate('/');
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    const menuItems = [
        { icon: LuBrain, label: t('menu.ideas'), to: '/crm/ideas', permissions: [PERMISSIONS.IDEAS.VIEW] },
        { icon: LuCalendar, label: t('menu.events'), to: '/crm/events', permissions: [PERMISSIONS.EVENTS.VIEW] },
        { icon: PiTag, label: t('menu.tags'), to: '/crm/tags', permissions: [PERMISSIONS.TAGS.VIEW] },
        { icon: TbUsersGroup, label: t('menu.users'), to: '/crm/users', permissions: [PERMISSIONS.USERS.VIEW] },
        { icon: IoSettingsOutline, label: t('menu.settings'), to: '/crm/settings' },
    ];

    return (
        <div className={`${styles.menu} ${isCollapsed ? styles.collapsed : ''}`}>
            <div className={styles.header}>
                <div className={styles.logoContainer}>
                    <img
                        src="/assets/menu-logo-mini.svg"
                        alt="Logo"
                        className={`${styles.logoIcon} ${isCollapsed ? styles.collapsed : ''}`}
                    />
                    {!isCollapsed && (
                        <span className={styles.logoText}>IDEARUM</span>
                    )}
                </div>
            </div>

            <button
                className={styles.toggleButton}
                onClick={onToggleCollapse}
                aria-label="Toggle sidebar"
            >
                {isCollapsed ? (
                    <IoChevronForward className={styles.toggleIcon} />
                ) : (
                    <IoChevronBack className={styles.toggleIcon} />
                )}
            </button>

            <nav className={styles.nav}>
                {menuItems.map((item, index) => (
                    <PermissionChecker key={index} permissions={item.permissions}>
                        <MenuItem
                            key={index}
                            icon={item.icon}
                            label={item.label}
                            to={item.to}
                            isCollapsed={isCollapsed}
                        />
                    </PermissionChecker>
                ))}
            </nav>

            <div className={styles.footer}>
                <button
                    onClick={handleLogout}
                    className={styles.logoutButton}
                >
                    <TbLogout2 className={styles.logoutIcon} />
                    {!isCollapsed && <span className={styles.logoutText}>{t('menu.logout')}</span>}
                </button>
            </div>
        </div>
    );
}

export default Menu;